import { render, staticRenderFns } from "./CAxAALxAcademicPage.vue?vue&type=template&id=ff7a0508"
import script from "./CAxAALxAcademicPage.vue?vue&type=script&lang=js"
export * from "./CAxAALxAcademicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports